
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-and-cookies",
      function () {
        return require("private-next-pages/privacy-and-cookies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-and-cookies"])
      });
    }
  